<template>
  <v-btn class="button-root"
    :color="color"
    :loading="loading"
    :disabled="loading"
    @click="click">
    <div>
      <slot />
    </div>
    <template v-slot:loader>
      <span class="custom-loader">
        <v-icon light>{{ svgPath }}</v-icon>
      </span>
    </template>
  </v-btn>
</template>

<script>
import { mdiCached } from "@mdi/js"; // eslint-disable-line import/no-extraneous-dependencies

export default {
  props: {
    color: {
      type: String,
      default: "#ff8c71"
    },
    onClick: {
      type: Function,
      default: null
    }
  },

  data() {
    return {
      loader: null,
      loading: false,
      svgPath: mdiCached
    };
  },

  methods: {
    async click(e) {
      this.$emit("click", e);
      if (this.onClick) {
        this.loading = true;
        await this.onClick(e);
        this.loading = false;
      }
      if (this.to) {
        this.$router.push(this.to).catch(() => null);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.button-root {
  display: flex;
  position: relative;
  border-radius: 3px;
  border: none;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding: 5px;
  cursor: pointer;
  outline: none;

  &.color-base {
    background-color: #007E57;
    &:active {
      background-color: #48AE84;
    }
  }

  &.color-blue {
    background-color: #5FAEDB;
    &:active {
      background-color: #94E0FF;
    }
  }

  &.color-yellow {
    background-color: #E38C00;
    &:active {
      background-color: #F2CB7B;
    }
  }

  &.color-red {
    background-color: #FF8C71;
    &:active {
      background-color: #FFBCA0;
    }
  }

  &.color-gray {
    background-color: #ccc;
    &:active {
      background-color: #ddd;
    }
  }
  &.color-orange {
    background-color: #ff8c71;
    &:active {
      background-color: #ff8c71;
    }
  }

  &.color-white {
    background-color: #fff;
    color: #777;
    border-color: #ccc;
    &:active {
      background-color: #EAEAEA;
    }
  }

  &.color-white-borderless {
    background-color: #fff;
    color: #000000;
    &:active {
      background-color: #EAEAEA;
    }
  }

  &.size-normal {
    min-width: 140px;
    min-height: 40px;
  }

  &.size-big {
    min-width: 240px;
    min-height: 50px;
    font-size: 18px;
  }

  &.size-small {
    min-width: 100px;
    min-height: 34px;
  }

  &.block {
    display: block;
    width: 100%;
    min-width: 0;
  }

  &.checkable {
    cursor: pointer;
  }

  &[disabled] {
    background-color: #eee;
    color: #fff;
    border-color: transparent;
    cursor: initial;

    &:active {
      background-color: #eee;
    }
  }
}
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(-360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(-360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(-360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(-360deg);
    }
  }
</style>
